@if (crmService.wizardLoading().isLoadingWizardStep) {
<zint-loader size="xSmall"></zint-loader>
}
<div class="zint-base-card d-flex justify-content-between w-100">
  <span>Enable import from {{crmType | titlecase}} to ZINT</span>
  <mat-slide-toggle [color]="'primary'" [(ngModel)]="isImportEnabled"
    (ngModelChange)="handleToggleImportMappings()">    
  </mat-slide-toggle>
</div>

  <div class="mt-3 crm-mapping-container" [ngClass]="{'import-disabled': !isImportEnabled}">  
    
    @if (crmService.wizardLoading().isLoadingWizardStepAction) {
    <zint-loader class="mx-auto" size="small" [overlay]="true" [dotColor]="'var(--zint-grey-500)'"></zint-loader>
    }

    <div class="crm-table-header row no-gutters">
      <div class="col-4">{{crmType | titlecase}} Field</div>
      <div class="col-4">ZINT Property</div>
      <div class="col-4 text-center">Action</div>
    </div>

    @if (selectedImportMappings.length < 1) { 
      <div class="crm-table-row row no-gutters justify-content-center">
        <button class="rounded-btn-base rounded-btn-light btn-p-sm" (click)="addMappingRow()">
          <i class="fas fa-plus"></i> Add New Mapping
        </button>
      </div>
    }
    @for (mapping of selectedImportMappings; let mapIndex = $index; track mapIndex) {
    <div class="crm-table-row row no-gutters">
      <div class="col-4">
        @if ($first) {
            <zint-autocomplete
              [options]="crmProperties"
              [displayProperty]="'label'"
              label="CRM property"
              [subscriptKey]="'name'"
              (optionSelected)="getCustomColsFromCRMFieldType($event, mapIndex)"
              >
            </zint-autocomplete>
            
            <button class="rounded-btn-base rounded-btn-white align-self-center refresh-fields-btn" matTooltip="Refresh fields"
              (click)="fetchCRMFields()">
              <i class="far fa-arrows-rotate fa-2xs text-vivid-blue"></i>
            </button>
        }
        @else {
          <span class="width-inherit text-break">{{mapping.crmField.label}}</span>
        }
        
      </div>
      <div class="col-4">
        @if ($first) {
          <zint-autocomplete
            [disabled]="!pubMethods.hasData(mapping.crmField)" 
            [options]="customColumns"
            [displayProperty]="'name'"
            label="ZINT Column"
            (optionSelected)="updateSelectedPropertyAtIndex(mapIndex, 'customColumn', $event)"
            [matTooltip]="pubMethods.hasData(mapping.crmField) ? '': 'Select a CRM Property first'"
          >
          </zint-autocomplete>

          @if (pubMethods.hasData(mapping.crmField)) {
            <div class="field-types-info">
              <small matTooltip="Available types: Text, Number, Date, User">Only showing columns compatible with
                CRM field type:&nbsp;<strong>{{currentCRMFieldType}}</strong></small>
            </div>
          }
        }
        @else { 
          <span class="width-inherit text-break">{{mapping.customColumn.name}}</span>
        }
      </div>
      
      <div class="col-4 text-center">
        @if ($first) {
        <button matTooltip="Add mapping" class="rounded-btn-base rounded-btn-vivid-outline btn-p-sm"
          (click)="confirmMappingAndAddMore(mapIndex)">
          <i class="fas fa-plus fa-xs"></i>
        </button>
        }
        @else {
          <button matTooltip="Remove mapping" class="rounded-btn-base rounded-btn-red-outline btn-p-sm"
            (click)="removeMapping(mapIndex)">
            <i class="fal fa-trash-can fa-xs"></i>
          </button>
        }
      </div>
    </div>
    }

  </div>